export const classes = {
  section: 'pt-3 pb-6 mx-12 w-full max-w-[900px]',
};
